import React from 'react';
import { DocumentTextIcon, Squares2X2Icon, MagnifyingGlassIcon } from '@heroicons/react/24/solid';

// Renomeado de navbar_bottom.jsx pra NavbarBottom.jsx (fase 3b) — mas a IMPLEMENTAÇÃO fica local,
// não vira wrapper de shared_items/NavbarBottom. Motivo: o terceiro slot não é uma tab de
// navegação, é um toggle de busca (onSearchToggle/isSearchOpen) com estilo próprio (círculo
// preenchido quando ativo) — nenhum outro módulo tem esse padrão. Forçar isso no componente
// genérico tornaria o shared_items/NavbarBottom mais complexo pra um caso único. Cor trocada
// de yellow-500 hardcoded pro token module-notepad.
const NavbarBottom = ({ activeTab, handleTabChange, onSearchToggle, isSearchOpen }) => {
  const showSearch = activeTab === 'notes' || activeTab === 'clusters';

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t grid grid-cols-3 items-center py-2 shadow-md">
      <button
        onClick={() => handleTabChange('notes')}
        className={`flex flex-col items-center justify-center text-xs min-w-0 py-1 ${activeTab === 'notes' ? 'text-module-notepad' : 'text-gray-400'}`}
      >
        <DocumentTextIcon className="h-6 w-6 mb-1 flex-shrink-0" />
        <span>Notes</span>
      </button>

      <button
        onClick={() => handleTabChange('clusters')}
        className={`flex flex-col items-center justify-center text-xs min-w-0 py-1 ${activeTab === 'clusters' ? 'text-module-notepad' : 'text-gray-400'}`}
      >
        <Squares2X2Icon className="h-6 w-6 mb-1 flex-shrink-0" />
        <span>Clusters</span>
      </button>

      {showSearch ? (
        <button
          type="button"
          onClick={onSearchToggle}
          className={`flex flex-col items-center justify-center min-w-0 py-1 transition-colors ${
            isSearchOpen
              ? 'text-module-notepad'
              : 'text-gray-400'
          }`}
          title="Buscar notas"
        >
          <span className={`flex items-center justify-center w-10 h-10 rounded-full border-2 flex-shrink-0 transition-colors ${
            isSearchOpen
              ? 'bg-module-notepad border-yellow-600 text-white'
              : 'border-current bg-transparent'
          }`}>
            <MagnifyingGlassIcon className="h-5 w-5" />
          </span>
        </button>
      ) : (
        <div className="min-w-0" aria-hidden />
      )}
    </div>
  );
};

export default NavbarBottom;
